export default __webpack_public_path__ + "img/shield.1b93522a.png";